// "Not today" hides a flag until tomorrow and records nothing else (§1) — so
// it cannot be `resolveFlag`, which is permanent. Client-side only, the same
// try/catch-wrapped localStorage pattern Routines' ticks already use.

const KEY = (id: string) => `mc.flagSnooze.${id}`;

export function isSnoozedToday(id: string, today: string): boolean {
  try { return localStorage.getItem(KEY(id)) === today; } catch { return false; }
}

export function snoozeToday(id: string, today: string) {
  try { localStorage.setItem(KEY(id), today); } catch { /* no storage, no memory */ }
}
